import React from 'react'
import RadioButton from '@/components/RadioButton'

const CheckBox = ({ classStyles, btnName, handleClick, checked }) => (
    <RadioButton
        btnName={btnName}
        classStyles={classStyles + ' ' + (checked ? 'nav__button' : 'nav__radio-button-unchecked')}
        handleClick={() => handleClick()}
        cancelBg={undefined}
    />
)

export default CheckBox
